// @flow
import * as React from 'react';
import { Label, Box, Text, Touchable } from 'gestalt';

type Props = {|
  error?: ?React.Node,
  children?: any,
  description?: ?React.Node,
  id: string,
  label?: string,
  required?: boolean,
  onLabelTouch?: () => void,
|};

export const Field = ({
  children,
  description,
  error,
  id,
  label,
  required,
  onLabelTouch,
}: Props) => (
  <Box>
    <Box marginBottom={1}>
      <Label htmlFor={id}>
        <Text color={!error ? 'darkGray' : 'red'}>
          {label}
          {required && (
            <Text color="red" bold inline>
              <span aria-hidden="true">*</span>
            </Text>
          )}
        </Text>
      </Label>
    </Box>
    {children}
    {(!!error || !!description) && (
      <Label htmlFor={id}>
        <Box marginTop={1}>
          {onLabelTouch ? (
            <Touchable onTouch={onLabelTouch}>
              <Text color={error ? 'red' : 'darkGray'} size="sm">
                {error || description}
              </Text>
            </Touchable>
          ) : (
            <Text color={error ? 'red' : 'darkGray'} size="sm">
              {error || description}
            </Text>
          )}
        </Box>
      </Label>
    )}
  </Box>
);

export default Field;
